/**
 * Internal dependencies
 */
export type SaveNewFolderDatalayerProps = {
	folderAmount: string;
	totalRecipeCount: string;
};

/**
 * Pushes an event to the data layer when a new folder is saved.
 * This is used for analytics tracking.
 * @param {SaveNewFolderDatalayerProps} props                  - The properties for the event.
 * @param {string}                      props.folderAmount     - The amount of folders.
 * @param {string}                      props.totalRecipeCount - The total number of recipes.
 * @return {void}
 */
export function pushKeittokirjaSaveNewFolder({
	folderAmount,
	totalRecipeCount,
}: SaveNewFolderDatalayerProps): void {
	const isProduction = Boolean(window.valioAnalytics.isProduction);
	const datalayerObject = {
		event: 'keittokirja_save_new_folder',
		folder_amount: folderAmount,
		total_recipe_count: totalRecipeCount,
	};

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(datalayerObject);

	if (!isProduction) {
		// eslint-disable-next-line no-console
		console.log('🔍 DataLayer: keittokirja_save_new_folder', datalayerObject);
	}
}
